export default __webpack_public_path__ + "static/6-newly-formed-countries-you-should-visit-ae0cc2a74a5c4353d6a1cdb7954b46f9.jpg";